import { pinnedBar } from './pinned-bar';

/**
 * The Site Analytics page's filter header (livewire/sites/analytics.blade.php): the filter bar pinned
 * to the top of the page's scroll area once the reader scrolls past it, folded there to one row
 * naming the period and every active filter (components/site-analytics/pinned-filters.blade.php),
 * whose Filters button opens the full bar in place. At the top of the page the full bar shows as it
 * always has. The behaviour is the report filter bar's (pinned-bar.js), at every width: folded, the
 * row is one line even on a phone.
 *
 * The chips' popovers are scopes of their own, and each moves focus into itself when it opens, so
 * focus inside the header is what keeps it from folding while one is open; nothing here moves focus
 * on its own. It pins under the Insights page's top bar, and while arranging under the edit bar too
 * (each bar's measured height).
 */
export default function SiteAnalyticsFilterHeader() {
    return {
        ...pinnedBar({
            section: '[data-site-analytics-filter-header]',
            sentinel: '[data-site-analytics-filter-sentinel]',
            toggle: '[data-site-analytics-filters-fold]',
            editBar: '[data-site-analytics-arrange-bar]',
            editBarHeight: '--site-analytics-edit-bar-height',
            topBarHeight: '--insights-header-height',
            height: '--site-analytics-filter-bar-height',
            pinnedAttribute: 'data-site-analytics-filters-pinned',
            editBarPinnedAttribute: 'data-site-analytics-edit-bar-pinned',
            gap: 12,
        }),

        init() {
            this.pin_start();
        },

        destroy() {
            this.pin_stop();
        },
    };
}
